// apiSlice.ts
import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from './ChatSlice'

export interface GenerateAISummary { id: number, story: string, doAnalytics?: boolean }
export const aiAnalyticsApi = createApi({
    reducerPath: 'aiAnalytics',
    //baseQuery: fetchBaseQuery(),
    baseQuery: baseQueryWithReauth,
    tagTypes: ['AiProfile', 'AiStorySearch'],
    endpoints: (builder) => ({
        //gest profile  by iam_is inserts if no matching profile found        
        AIProfileSummary: builder.query<any, number>({
            query: (id) => {
                const qry = `/api/ai/AIProfileSummary/${id}`
                return qry
            },
            providesTags: (result, response, idRetrieved) => {
                return [{ type: 'AiProfile', id: idRetrieved }]
            }
        }),

        generateAISummary: builder.mutation<any, GenerateAISummary>({
            query: ({ id, story, doAnalytics }) => ({
                url: `/api/ai/generateAISummary/`,
                method: 'POST',
                body: { id: id, story: story, doAnalytics: doAnalytics ? true : false }
            }),
            invalidatesTags: (result, response, updated) => [{
                type: 'AiProfile', id: updated.id
            }]
        }),

        getSearchByStory: builder.query<any, { id: number, authStatus: string, story: string }>({// = createAsyncThunk("search/getSearchByStory", async (data, thunkAPI) => {
            query: ({ id, authStatus, story }) => {
                const qry = `/api/ai/searchbystory?id=${id}&authStatus=${authStatus}&story=${story}`
                return qry
            },
            providesTags: (result, response, ) => {
                return [ 'AiStorySearch']
            }
        }),
        askAgent: builder.mutation<any, { profileId: number, userPrompt: string, authStatus: string }>({// = createAsyncThunk("search/getSearchByStory", async (data, thunkAPI) => {
            query: ({ profileId,  userPrompt , authStatus }) => ({
                url: `/api/ai/askAgent/`,
                method: 'POST',
                body: {  profileId, userPrompt, authStatus}
            }),
            // providesTags: (result, response, ) => {
            //     return [ 'AiStorySearch']
            // }
        }),
    }),
})


export const { useAIProfileSummaryQuery, useGenerateAISummaryMutation, useGetSearchByStoryQuery, useLazyGetSearchByStoryQuery, useAskAgentMutation} = aiAnalyticsApi

//export const createQueryArgs = (id, otherProp) => ({ id, otherProp });


